<app-global-payment-form #globalPaymentFormComponent [price]="price" [service]="'housing-certificate'"
                         [text]="'PROCESSES.HOUSING_CERTIFICATE.PAYMENT.SUBTITLE'" [nextUrl]="'housing-certificate/post-payment'" [process]="'housing-certificate'"
                         (sendLoadingStatus)="isLoading = $event" [promoCode]="promoCode" [pdfKey]="'ATT_LGT'" (hasButtonDisplay)="displayButton($event)"></app-global-payment-form>

<app-faq-accordion [faqFields]="FaqItems" [firstExpanded]="true" class="d-none d-lg-block"></app-faq-accordion>

<app-need-help></app-need-help>
<div class="position-sticky mt-3 bg-white py-3 pb-lg-0 bottom_sticky" *ngIf="displayBtn">
  <button class="btn btn-primary w-100 fw-bold" (click)="pay()" [ngClass]="isMobile ? 'py-4 font-24' : 'py-3'" checkFormError>
    <span class="material-icons-outlined me-1 va-sub" [ngClass]="isMobile ? 'font-24' : 'font-20'" *ngIf="!isLoading">euro</span>
    <span *ngIf="isLoading"  class="spinner-border spinner-border-sm me-1 v-middle" ></span>
    {{ 'PROCESSES.HOUSING_CERTIFICATE.PAY' | translate }}
  </button>
</div>
